import React from 'react';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { TableActions, TableRow, TableCell } from 'components/Tables';
import { useSubscription } from 'utils/hooks';

export default function Rows({
  carriers = [],
  isDisabled = false,
  onEdit = () => {},
  onToggle = () => {}
}) {
  const { isByocStore } = useSubscription();

  return carriers.map(carrier => {
    const id = _get(carrier, 'id', '');
    const name = _get(carrier, 'name', '');
    const slas = _get(carrier, 'slas', []);
    const isByoc = _get(carrier, 'is_byoc', false);
    const carrierId = _get(carrier, 'carrier_id', '');
    const isEnabled = _get(carrier, 'is_enabled', false);

    const totalSlas = slas.length;
    const enabledSlasCount = slas.reduce((acc, sla) => {
      const isActive = _get(sla, 'is_active', false);
      return acc + Number(isActive);
    }, 0);
    const areAllSlasSelected = totalSlas === enabledSlasCount;
    const isActionDisabled = (isByoc && !isByocStore) || isDisabled;

    return (
      <TableRow
        key={id}
        values={[
          {
            lg: 6,
            CustomComponent: (
              <TableCell.Toggle
                isActive={isEnabled}
                onChange={() => onToggle(carrier)}
                disabled={isActionDisabled}
                title={
                  <div className={styles.cell}>
                    {name}
                    <If test={isByoc}>
                      <UiKit.Badge>Your Carrier Account</UiKit.Badge>
                    </If>
                  </div>
                }
              />
            )
          },
          {
            lg: 3,
            title: carrierId
          },
          {
            lg: 2,
            title: `${
              areAllSlasSelected ? 'All' : `${enabledSlasCount} of`
            } ${totalSlas} services`
          },
          {
            lg: 1,
            CustomComponent: (
              <TableActions
                permissions={{ edit: true }}
                edit={() => onEdit(carrier)}
                disableEditBtn={isActionDisabled}
              />
            )
          }
        ]}
      />
    );
  });
}
